import MFileUploader from './MFileUploader.vue';

MFileUploader.install = (app) => {
  app.component('MFileUploader', MFileUploader);
};

export { MFileUploader };
